const data = state => state.user.data
const initialised = state => state.user.initialised

const selectors = {
  data,
  initialised,
}

export default selectors
